// import { AntButton } from '@/common/ant-components/AntButton';
// import DraggableModal from '@/common/ant-components/DraggableModal';
// import { useTransactionContext } from '@/context/TransactionContext';
// import { CopyOutlined, SaveOutlined } from '@ant-design/icons';
// import { Tooltip } from 'antd';
// import { useState, useEffect } from 'react';
// const Calculator = () => {
//   const [input, setInput] = useState('');

//   const { result, setResult } = useTransactionContext();

//   const handleClick = (value) => {
//     if (value === 'C') {
//       setInput('');
//       setResult('');
//     } else if (value === '⌫') {
//       setInput((prev) => prev.slice(0, -1));
//     } else if (value !== '=') {
//       setInput((prev) => prev + value);
//     }
//   };

//   useEffect(() => {
//     if (!input) {
//       setResult('');
//       return;
//     }

//     try {
//       const lastChar = input.trim().slice(-1);
//       if (!['+', '-', '*', '/'].includes(lastChar)) {
//         // eslint-disable-next-line no-eval
//         const evalResult = eval(input);
//         setResult(evalResult.toString());
//       }
//     } catch {
//       setResult('');
//     }
//   }, [input]);

//   const buttons = [
//     '7',
//     '8',
//     '9',
//     '/',
//     '4',
//     '5',
//     '6',
//     '*',
//     '1',
//     '2',
//     '3',
//     '-',
//     '0',
//     '.',
//     '=',
//     '+',
//     'C',
//     '⌫',
//   ];

//   return (
//     <div
//       style={{
//         width: 260,
//         padding: 16,
//         backgroundColor: '#fefefe',
//         borderRadius: 10,
//         boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
//         fontFamily: 'monospace',
//       }}
//     >
//       <div
//         style={{
//           marginBottom: 12,
//           padding: '12px 10px',
//           border: '1px solid #ddd',
//           borderRadius: 8,
//           textAlign: 'right',
//           backgroundColor: '#fafafa',
//           minHeight: 70,
//           boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)',
//           userSelect: 'none',
//           wordWrap: 'break-word',
//         }}
//       >
//         <div
//           style={{
//             fontSize: 18,
//             color: '#444',
//             fontWeight: '500',
//             marginBottom: 4,
//             wordBreak: 'break-word',
//           }}
//         >
//           {input || '0'}
//         </div>
//         {result !== '' && (
//           <div
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'right',
//               gap: 8,
//               fontSize: 22,
//               fontWeight: 'bold',
//               color: '#1677ff',
//               wordBreak: 'break-word',
//             }}
//           >
//             <span>= {result}</span>
//             <Tooltip title="Copy result">
//               <button
//                 onClick={() => navigator.clipboard.writeText(result)}
//                 style={{
//                   border: 'none',
//                   background: 'transparent',
//                   cursor: 'pointer',
//                   fontSize: 18,
//                   color: '#1677ff',
//                 }}
//               >
//                 <CopyOutlined />
//               </button>
//             </Tooltip>
//           </div>
//         )}
//       </div>

//       <div
//         style={{
//           display: 'grid',
//           gridTemplateColumns: 'repeat(4, 1fr)',
//           gap: 8,
//         }}
//       >
//         {buttons.map((btn) => (
//           <button
//             key={btn}
//             onClick={() => handleClick(btn)}
//             style={{
//               padding: '12px 0',
//               fontSize: 16,
//               borderRadius: 6,
//               border: 'none',
//               backgroundColor:
//                 btn === '='
//                   ? '#1677ff'
//                   : btn === 'C'
//                     ? '#ff4d4f'
//                     : btn === '⌫'
//                       ? '#ffa940'
//                       : '#f5f5f5',
//               color:
//                 btn === '=' || btn === 'C' || btn === '⌫' ? '#fff' : '#333',
//               cursor: 'pointer',
//               transition: 'all 0.2s ease',
//               boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
//             }}
//             title={btn === '⌫' ? 'Delete one character' : undefined}
//           >
//             {btn}
//           </button>
//         ))}
//       </div>
//     </div>
//   );
// };

// const CalculatorAppWithModal = (props) => {
//   const { form, formData } = props;
//   const { onFieldChange } = props;
//   const { calculatorOpen, setCalculatorOpen, result, targetId } =
//     useTransactionContext();

//   return (
//     <DraggableModal
//       open={calculatorOpen}
//       onCancel={() => {
//         setCalculatorOpen(false);
//       }}
//       onClose={() => {
//         setCalculatorOpen(false);
//       }}
//       width={300}
//       centered
//       title={
//         <div className="tw-text-center tw-font-[600] tw-text-base">
//           Calculator
//         </div>
//       }
//     >
//       <div className="tw-flex tw-justify-center tw-items-center tw-gap-x-3 tw-mt-2 tw-gap-y-2">
//         <Calculator />
//       </div>

//       <div className="tw-flex tw-justify-end tw-mt-2">
//         <AntButton
//           onClick={() => {
//             setCalculatorOpen(false);
//             form.setFieldsValue({
//               ...formData,
//               ...form.getFieldsValue(),
//               [targetId]: result || 0,
//             });
//             if (targetId) {
//               onFieldChange(targetId, result);
//             }
//           }}
//           size="small"
//           className="tw-h-[28px]"
//           icon={<SaveOutlined />}
//         >
//           Save
//         </AntButton>
//       </div>
//       <div></div>
//     </DraggableModal>
//   );
// };

// export default CalculatorAppWithModal;

// import { AntButton } from '@/common/ant-components/AntButton';
// import DraggableModal from '@/common/ant-components/DraggableModal';
// import { useTransactionContext } from '@/context/TransactionContext';
// import { CopyOutlined, SaveOutlined } from '@ant-design/icons';
// import { Tooltip } from 'antd';
// import { useState, useEffect, useRef } from 'react';

// const Calculator = () => {
//   const [input, setInput] = useState('');
//   const { result, setResult } = useTransactionContext();
//   const containerRef = useRef(null);

//   const handleClick = (value) => {
//     if (value === 'C') {
//       setInput('');
//       setResult('');
//     } else if (value === '⌫') {
//       setInput((prev) => prev.slice(0, -1));
//     } else if (value !== '=') {
//       setInput((prev) => prev + value);
//     }
//   };

//   useEffect(() => {
//     if (!input) {
//       setResult('');
//       return;
//     }

//     try {
//       const lastChar = input.trim().slice(-1);
//       if (!['+', '-', '*', '/'].includes(lastChar)) {
//         // eslint-disable-next-line no-eval
//         const evalResult = eval(input);
//         setResult(evalResult.toString());
//       }
//     } catch {
//       setResult('');
//     }
//   }, [input]);

//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       const { key } = e;

//       if (key === 'Enter' || key === '=') {
//         e.preventDefault();
//       } else if (key === 'Backspace') {
//         handleClick('⌫');
//       } else if (key === 'Escape') {
//         handleClick('C');
//       } else if (/[\d+\-*/.]/.test(key)) {
//         handleClick(key);
//       }
//     };

//     window.addEventListener('keydown', handleKeyDown);
//     return () => window.removeEventListener('keydown', handleKeyDown);
//   }, []);

//   const buttons = [
//     '7',
//     '8',
//     '9',
//     '/',
//     '4',
//     '5',
//     '6',
//     '*',
//     '1',
//     '2',
//     '3',
//     '-',
//     '0',
//     '.',
//     '=',
//     '+',
//     'C',
//     '⌫',
//   ];

//   return (
//     <div
//       ref={containerRef}
//       style={{
//         width: 260,
//         padding: 16,
//         backgroundColor: '#fefefe',
//         borderRadius: 10,
//         boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
//         fontFamily: 'monospace',
//       }}
//     >
//       <div
//         style={{
//           marginBottom: 12,
//           padding: '12px 10px',
//           border: '1px solid #ddd',
//           borderRadius: 8,
//           textAlign: 'right',
//           backgroundColor: '#fafafa',
//           minHeight: 70,
//           boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)',
//           userSelect: 'none',
//           wordWrap: 'break-word',
//         }}
//       >
//         <div
//           style={{
//             fontSize: 18,
//             color: '#444',
//             fontWeight: '500',
//             marginBottom: 4,
//             wordBreak: 'break-word',
//           }}
//         >
//           {input || '0'}
//         </div>
//         {result !== '' && (
//           <div
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'right',
//               gap: 8,
//               fontSize: 22,
//               fontWeight: 'bold',
//               color: '#1677ff',
//               wordBreak: 'break-word',
//             }}
//           >
//             <span>= {result}</span>
//             <Tooltip title="Copy result">
//               <button
//                 onClick={() => navigator.clipboard.writeText(result)}
//                 style={{
//                   border: 'none',
//                   background: 'transparent',
//                   cursor: 'pointer',
//                   fontSize: 18,
//                   color: '#1677ff',
//                 }}
//               >
//                 <CopyOutlined />
//               </button>
//             </Tooltip>
//           </div>
//         )}
//       </div>

//       <div
//         style={{
//           display: 'grid',
//           gridTemplateColumns: 'repeat(4, 1fr)',
//           gap: 8,
//         }}
//       >
//         {buttons.map((btn) => (
//           <button
//             key={btn}
//             onClick={() => handleClick(btn)}
//             style={{
//               padding: '12px 0',
//               fontSize: 16,
//               borderRadius: 6,
//               border: 'none',
//               backgroundColor:
//                 btn === '='
//                   ? '#1677ff'
//                   : btn === 'C'
//                     ? '#ff4d4f'
//                     : btn === '⌫'
//                       ? '#ffa940'
//                       : '#f5f5f5',
//               color:
//                 btn === '=' || btn === 'C' || btn === '⌫' ? '#fff' : '#333',
//               cursor: 'pointer',
//               transition: 'all 0.2s ease',
//               boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
//             }}
//             title={btn === '⌫' ? 'Delete one character' : undefined}
//           >
//             {btn}
//           </button>
//         ))}
//       </div>
//     </div>
//   );
// };

// const CalculatorAppWithModal = (props) => {
//   const { form, formData, onFieldChange } = props;
//   const { calculatorOpen, setCalculatorOpen, result, targetId } =
//     useTransactionContext();

//   const handleSave = () => {
//     setCalculatorOpen(false);
//     form.setFieldsValue({
//       ...formData,
//       ...form.getFieldsValue(),
//       [targetId]: result || 0,
//     });
//     if (targetId) {
//       onFieldChange(targetId, result);
//     }
//   };

//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (e.key === 'F12') {
//         e.preventDefault();
//         if (calculatorOpen) {
//           handleSave();
//         }
//       }
//     };

//     window.addEventListener('keydown', handleKeyDown);
//     return () => window.removeEventListener('keydown', handleKeyDown);
//   }, [calculatorOpen, result, targetId]);

//   return (
//     <DraggableModal
//       open={calculatorOpen}
//       onCancel={() => setCalculatorOpen(false)}
//       onClose={() => setCalculatorOpen(false)}
//       width={300}
//       centered
//       title={
//         <div className="tw-text-center tw-font-[600] tw-text-base">
//           Calculator
//         </div>
//       }
//     >
//       <div className="tw-flex tw-justify-center tw-items-center tw-gap-x-3 tw-mt-2 tw-gap-y-2">
//         <Calculator />
//       </div>

//       <div className="tw-flex tw-justify-end tw-mt-2">
//         <AntButton
//           onClick={() => {
//             setCalculatorOpen(false);
//             form.setFieldsValue({
//               ...formData,
//               ...form.getFieldsValue(),
//               [targetId]: parseFloat(result || 0)?.toFixed(3) || 0,
//             });
//             if (targetId) {
//               onFieldChange(targetId, parseFloat(result || 0)?.toFixed(3));
//             }
//           }}
//           size="small"
//           className="tw-h-[28px]"
//           icon={<SaveOutlined />}
//         >
//           Save
//         </AntButton>
//       </div>
//     </DraggableModal>
//   );
// };

// export default CalculatorAppWithModal;

import { AntButton } from '@/common/ant-components/AntButton';
import DraggableModal from '@/common/ant-components/DraggableModal';
import { useTransactionContext } from '@/context/TransactionContext';
import {
  CloseCircleFilled,
  CopyOutlined,
  SaveOutlined,
} from '@ant-design/icons';
import { message, Tooltip } from 'antd';
import { parse } from 'date-fns';
import { useState, useEffect, useRef } from 'react';

const Calculator = () => {
  const [input, setInput] = useState('');
  const { result, setResult } = useTransactionContext();
  const containerRef = useRef(null);

  const handleClick = (value) => {
    if (value === 'C') {
      setInput('');
      setResult('');
    } else if (value === '⌫') {
      setInput((prev) => prev.slice(0, -1));
    } else if (value !== '=') {
      setInput((prev) => prev + value);
    }
  };

  useEffect(() => {
    if (!input) {
      setResult('');
      return;
    }

    try {
      const lastChar = input.trim().slice(-1);
      if (!['+', '-', '*', '/'].includes(lastChar)) {
        // Replace eval with a safer alternative (e.g., mathjs) if possible
        // eslint-disable-next-line no-eval
        const evalResult = eval(input);
        setResult(evalResult.toString());
      }
    } catch {
      setResult('');
    }
  }, [input]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      const { key } = e;

      // Prevent F12 from being processed as input
      if (key === 'F12') {
        e.preventDefault();
        return; // Do not process F12 as input
      }

      // Handle calculator-specific keys
      if (key === 'Enter' || key === '=') {
        e.preventDefault();
      } else if (key === 'Backspace') {
        e.preventDefault(); // Prevent default backspace behavior
        handleClick('⌫');
      } else if (key === 'Escape') {
        e.preventDefault(); // Prevent default escape behavior
        handleClick('C');
      } else if (/^[0-9+\-*/.]$/.test(key)) {
        // Only allow digits, operators, and decimal point
        e.preventDefault(); // Prevent default to control input
        handleClick(key);
      }
      // Ignore all other keys (e.g., letters, function keys, etc.)
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const buttons = [
    '7',
    '8',
    '9',
    '/',
    '4',
    '5',
    '6',
    '*',
    '1',
    '2',
    '3',
    '-',
    '0',
    '.',
    '=',
    '+',
    'C',
    '⌫',
  ];

  return (
    <div
      ref={containerRef}
      style={{
        width: 260,
        padding: 16,
        backgroundColor: '#fefefe',
        borderRadius: 10,
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        fontFamily: 'monospace',
      }}
    >
      <div
        style={{
          marginBottom: 12,
          padding: '12px 10px',
          border: '1px solid #ddd',
          borderRadius: 8,
          textAlign: 'right',
          backgroundColor: '#fafafa',
          minHeight: 70,
          boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)',
          userSelect: 'none',
          wordWrap: 'break-word',
        }}
      >
        <div
          style={{
            fontSize: 18,
            color: '#444',
            fontWeight: '500',
            marginBottom: 4,
            wordBreak: 'break-word',
          }}
        >
          {input || '0'}
        </div>
        {result !== '' && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'right',
              gap: 8,
              fontSize: 22,
              fontWeight: 'bold',
              color: '#1677ff',
              wordBreak: 'break-word',
            }}
          >
            <span>= {result}</span>
            <Tooltip title="Copy result">
              <button
                onClick={() => navigator.clipboard.writeText(result)}
                style={{
                  border: 'none',
                  background: 'transparent',
                  cursor: 'pointer',
                  fontSize: 18,
                  color: '#1677ff',
                }}
              >
                <CopyOutlined />
              </button>
            </Tooltip>
          </div>
        )}
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 8,
        }}
      >
        {buttons.map((btn) => (
          <button
            key={btn}
            onClick={() => handleClick(btn)}
            style={{
              padding: '12px 0',
              fontSize: 16,
              borderRadius: 6,
              border: 'none',
              backgroundColor:
                btn === '='
                  ? '#1677ff'
                  : btn === 'C'
                    ? '#ff4d4f'
                    : btn === '⌫'
                      ? '#ffa940'
                      : '#f5f5f5',
              color:
                btn === '=' || btn === 'C' || btn === '⌫' ? '#fff' : '#333',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
            }}
            title={btn === '⌫' ? 'Delete one character' : undefined}
          >
            {btn}
          </button>
        ))}
      </div>
    </div>
  );
};

const CalculatorAppWithModal = (props) => {
  const { form, formData, onFieldChange } = props;
  const { calculatorOpen, setCalculatorOpen, result, targetId } =
    useTransactionContext();

  // const handleSave = () => {
  //   setCalculatorOpen(false);
  //   form.setFieldsValue({
  //     ...formData,
  //     ...form.getFieldsValue(),
  //     [targetId]: parseFloat(result || 0)?.toFixed(3) || 0,
  //   });
  //   if (targetId) {
  //     onFieldChange(targetId, parseFloat(result || 0)?.toFixed(3));
  //   }
  // };

  const handleSave = () => {
    setCalculatorOpen(false);
    const parsed = parseFloat(result);

    const isValidNumber = !isNaN(parsed) && isFinite(parsed) && parsed !== null;

    if (isValidNumber && targetId) {
      const formatted =
        targetId === 'grossWeight' ? parsed.toFixed(1) : parsed.toFixed(3);
      form.setFieldsValue({
        ...formData,
        ...form.getFieldsValue(),
        [targetId]: formatted,
      });
      onFieldChange && onFieldChange(targetId, formatted);
    } else {
      message.warning('Invalid calculator value. Please enter a valid number.');
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'F12') {
        e.preventDefault();
        if (calculatorOpen) {
          handleSave();
        }
      }
      if (e.key === 'Escape') {
        e.preventDefault();
        setCalculatorOpen(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [calculatorOpen, result, targetId]);

  return (
    <DraggableModal
      open={calculatorOpen}
      onCancel={() => setCalculatorOpen(false)}
      onClose={() => setCalculatorOpen(false)}
      width={300}
      centered
      title={
        <div className="tw-text-center tw-font-[600] tw-text-base">
          Calculator
        </div>
      }
    >
      <div className="tw-flex tw-justify-center tw-items-center tw-gap-x-3 tw-mt-2 tw-gap-y-2">
        <Calculator />
      </div>
      <div className="tw-flex tw-gap-x-2 tw-justify-end tw-mt-2">
        <AntButton
          onClick={() => {
            const parsed = parseFloat(result || 0);

            const isValidNumber =
              !isNaN(parsed) && isFinite(parsed) && parsed !== null;

            if (isValidNumber && targetId) {
              const formatted =
                targetId === 'grossWeight'
                  ? parsed.toFixed(1)
                  : parsed.toFixed(3);
              form.setFieldsValue({
                ...formData,
                ...form.getFieldsValue(),
                [targetId]: formatted,
              });
              onFieldChange && onFieldChange(targetId, formatted);
            } else {
              message.warning(
                'Invalid calculator value. Please enter a valid calculation.',
              );
            }
            setCalculatorOpen(false);
          }}
          size="small"
          className="tw-h-[28px]"
          icon={<SaveOutlined />}
        >
          Save [F12]
        </AntButton>
      </div>
    </DraggableModal>
  );
};

export default CalculatorAppWithModal;
